import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Grid, Container, CssBaseline, makeStyles } from '@material-ui/core';
import formStyles from '../../../assets/jss/components/formStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import GRAPHIC from '../../../assets/images/login_graphic.svg';
import EnhancedAddDiagnosisForm from './EnhancedAddDiagnosisForm';
import { DisplayDiagnosis } from './DisplayDiagnosis';
import theme from '../../../app/muiTheme';

interface IAddDiagnosisProps {}
const useStyles = makeStyles(formStyles);

const AddDiagnosis: React.FC<IAddDiagnosisProps> = ({}) => {
  const classes = useStyles();
  const history = useHistory();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <div style={{ paddingTop: '1vh' }}>
      <Container style={{ padding: '0.4em', height: '80vh' }}>
        <Grid
          container
          direction='row'
          justifyContent='flex-start'
          alignItems='flex-start'
        >
          <Grid item xs={12} md={6}>
            <CssBaseline />
            <EnhancedAddDiagnosisForm />
            <DisplayDiagnosis />
          </Grid>
          <Grid item xs={12} md={6}>
            {/* {matches&&
              <div style={{ padding: '1em', marginLeft: '2em' }}>
                <img src={GRAPHIC} />
              </div>
            } */}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default AddDiagnosis;
